// Libraries
import { NgModule }       from '@angular/core';
import { CommonModule, DatePipe }   from '@angular/common';
import { FormsModule }    from '@angular/forms';

// Components
import { MonthYearPickerComponent } from './month-year-picker.component';

// Pipes
import { MonthNamePipe } from './month-name.pipe';
/**
 * `MonthYearPickerModule` defines a module manage month year picker.
 */
@NgModule({
  declarations: [
    MonthYearPickerComponent,
    MonthNamePipe
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  providers: [
    DatePipe
  ],
  exports: [
    MonthYearPickerComponent
  ]
})
export class MonthYearPickerModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/month-year-picker/month-year-picker.module.ts